import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, filter, take, tap, map } from 'rxjs/operators';
import { loadAllLocales } from '@app/store/app.actions';
import { selectAllLocales } from '@app/store/app.selectors';
import { AppState } from '@app/store/app.reducer';

@Injectable({
  providedIn: 'root'
})
export class LocalesResolver implements Resolve<boolean> {
  constructor(private store: Store<AppState>) {}

  resolve(): Observable<boolean> {
    return this.store.select(selectAllLocales).pipe(
      tap(locales => {
        if (!locales) {
          this.store.dispatch(loadAllLocales());
        }
      }),
      filter(locales => !!locales),
      take(1),
      map(() => true),
      catchError(() => of(false)) // Or handle error appropriately
    );
  }
} 